const defaultState = {
    isGrabbable: false,
    isGrabbing: false,
    isZooming: false,
    x: -1,
    y: -1,
    icon: null
}


export default function(state = defaultState, action) {
    switch (action.type) {
        case 'SET_CURSOR': {

            console.log (action)

            return Object.assign({},
                state,
                action.cursorState
            )
        }

        default: {
            return state;
        }
    }
}